import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';

const emptyForm = {
  nome: '',
  apertura_mattina: '08:30',
  chiusura_mattina: '13:00',
  apertura_pomeriggio: '13:30',
  chiusura_pomeriggio: '19:00',
};

const formatTime = (value) => (value ? String(value).slice(0, 5) : '');

const GestioneSedi = () => {
  const [sedi, setSedi] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState({});

  const fetchSedi = async () => {
    try {
      const res = await api.get('/sedi');
      setSedi(res.data);
    } catch (error) {
      alert('Errore nel recupero delle sedi');
    }
  };

  useEffect(() => {
    fetchSedi();
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/sedi', form);
      setForm(emptyForm);
      fetchSedi();
    } catch (error) {
      alert(error.response?.data?.message || 'Errore creazione sede');
    }
  };

  const handleEditChange = (id, field, value) => {
    setEditing((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  const handleSave = async (sede) => {
    const edit = editing[sede.sede_id] || {};
    const payload = {
      nome: edit.nome ?? sede.nome,
      apertura_mattina: edit.apertura_mattina ?? formatTime(sede.apertura_mattina),
      chiusura_mattina: edit.chiusura_mattina ?? formatTime(sede.chiusura_mattina),
      apertura_pomeriggio: edit.apertura_pomeriggio ?? formatTime(sede.apertura_pomeriggio),
      chiusura_pomeriggio: edit.chiusura_pomeriggio ?? formatTime(sede.chiusura_pomeriggio),
    };
    try {
      await api.put(`/sedi/${sede.sede_id}`, payload);
      setEditing((prev) => {
        const next = { ...prev };
        delete next[sede.sede_id];
        return next;
      });
      fetchSedi();
    } catch (error) {
      alert(error.response?.data?.message || 'Errore salvataggio sede');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questa sede? Gli utenti associati perderanno l\'assegnazione.')) {
      return;
    }
    try {
      await api.delete(`/sedi/${id}`);
      fetchSedi();
    } catch (error) {
      alert('Errore eliminazione sede');
    }
  };

  return (
    <div>
      <h2>🏢 Gestione Sedi</h2>

      <form onSubmit={handleCreate} style={{ marginBottom: '30px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        <input
          name="nome"
          placeholder="Nome sede"
          value={form.nome}
          onChange={handleFormChange}
          required
        />
        <input
          type="time"
          name="apertura_mattina"
          value={form.apertura_mattina}
          onChange={handleFormChange}
          required
        />
        <input
          type="time"
          name="chiusura_mattina"
          value={form.chiusura_mattina}
          onChange={handleFormChange}
          required
        />
        <input
          type="time"
          name="apertura_pomeriggio"
          value={form.apertura_pomeriggio}
          onChange={handleFormChange}
          required
        />
        <input
          type="time"
          name="chiusura_pomeriggio"
          value={form.chiusura_pomeriggio}
          onChange={handleFormChange}
          required
        />
        <button type="submit">➕ Aggiungi sede</button>
      </form>

      <table border="1" cellPadding="6" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Apertura Mattina</th>
            <th>Chiusura Mattina</th>
            <th>Apertura Pomeriggio</th>
            <th>Chiusura Pomeriggio</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {sedi.map((sede) => {
            const edit = editing[sede.sede_id] || {};
            return (
              <tr key={sede.sede_id}>
                <td>
                  <input
                    value={edit.nome ?? sede.nome}
                    onChange={(e) => handleEditChange(sede.sede_id, 'nome', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    value={edit.apertura_mattina ?? formatTime(sede.apertura_mattina)}
                    onChange={(e) => handleEditChange(sede.sede_id, 'apertura_mattina', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    value={edit.chiusura_mattina ?? formatTime(sede.chiusura_mattina)}
                    onChange={(e) => handleEditChange(sede.sede_id, 'chiusura_mattina', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    value={edit.apertura_pomeriggio ?? formatTime(sede.apertura_pomeriggio)}
                    onChange={(e) => handleEditChange(sede.sede_id, 'apertura_pomeriggio', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    value={edit.chiusura_pomeriggio ?? formatTime(sede.chiusura_pomeriggio)}
                    onChange={(e) => handleEditChange(sede.sede_id, 'chiusura_pomeriggio', e.target.value)}
                  />
                </td>
                <td>
                  <button onClick={() => handleSave(sede)}>💾 Salva</button>
                  <button onClick={() => handleDelete(sede.sede_id)} style={{ marginLeft: '8px' }}>
                    🗑️ Elimina
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GestioneSedi;

